export default __webpack_public_path__ + "static/media/bg_library.306b8957.jpg";